import { Component, Injector, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';


@Component({
  selector: 'app-rules-page',
  templateUrl: './rules-page.component.html',
  styleUrls: ['./rules-page.component.css']
})
export class RulesPageComponent extends BaseClass<any> implements OnInit {
  public bonusRules: boolean = false;
  public key: any;
  public data: any;
  public bsModalRef!: BsModalRef;
  constructor(private injector: Injector, public service: WebserviceService) {
    super(document)
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnInit(): void {
    if (this.key?.bonus) {
      this.bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
      this.bonusRules = true;
      this.getData();
    }
  }

  getData() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.bonusRules}`).subscribe(
      (res) => {
        this.isLoad = false;
        if (res?.status == true) {
          this.data = res?.data?.rules;
          // let doc = this.document.getElementById('bonus-rule') as HTMLElement;
          // doc.innerHTML = res?.data?.rules;
        }
      },
      (err) => {
        console.log(err);
      });
  }

}
